import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "mb-2 session-date" }
const _hoisted_3 = { class: "fs-3 fw-bold" }
const _hoisted_4 = { class: "ms-2 fs-4 session-time" }
const _hoisted_5 = { class: "mb-4 row g-4" }
const _hoisted_6 = { class: "col-12 col-lg-6" }
const _hoisted_7 = { class: "mb-3 d-flex flex-wrap session-categories" }
const _hoisted_8 = { class: "mb-1 session-label" }
const _hoisted_9 = { class: "badge text-bg-dark" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "mb-3 session-level"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2 badge text-bg-dark rounded text-nowrap" }, "内容レベル")
], -1)
const _hoisted_15 = { class: "small" }
const _hoisted_16 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 1,
  class: "mb-3 session-participants"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2 badge text-bg-dark rounded text-nowrap" }, "参加対象者")
], -1)
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 2,
  class: "mb-3 session-merit"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2 badge text-bg-dark rounded text-nowrap" }, "受講するメリット")
], -1)
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 3,
  class: "mb-3 session-needs"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2 badge text-bg-dark rounded text-nowrap" }, "こんなニーズや悩みに答えられる内容です")
], -1)
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "col-12 col-lg-4" }
const _hoisted_28 = { class: "mb-1 speaker-role" }
const _hoisted_29 = { class: "badge text-bg-dark rounded" }
const _hoisted_30 = { class: "row g-2" }
const _hoisted_31 = { class: "col-12 col-lg-3 text-center speaker-photo" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "col-12 col-lg-9" }
const _hoisted_34 = { class: "fs-lg-8" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "fs-5 fw-bold speaker-name" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 small fw-normal" }, "氏", -1)
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "col-12 col-lg-2" }
const _hoisted_42 = { class: "p-3 session-image" }
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "mx-auto w-lg-75" }
const _hoisted_45 = {
  key: 0,
  class: "mb-2 row row-cols-1 g-2"
}
const _hoisted_46 = {
  key: 0,
  class: "col text-center session-zoom"
}
const _hoisted_47 = { class: "icon icon-start icon-me-2 icon-zoom" }
const _hoisted_48 = {
  key: 1,
  class: "col text-center session-zoom-alt"
}
const _hoisted_49 = { class: "icon icon-start icon-me-2 icon-movie" }
const _hoisted_50 = { class: "col text-center" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "icon icon-start icon-me-2 icon-document" }
const _hoisted_53 = {
  key: 1,
  class: "btn btn-sm btn-secondary w-100 disabled session-document pe-none",
  disabled: ""
}
const _hoisted_54 = { class: "icon icon-start icon-me-2 icon-document" }
const _hoisted_55 = {
  key: 2,
  class: "btn btn-sm btn-outline-secondary w-100 disabled session-document pe-none",
  disabled: ""
}
const _hoisted_56 = { class: "icon icon-start icon-me-2 icon-document" }
const _hoisted_57 = { class: "row row-cols-1 row-cols-lg-2 g-2 justify-content-center" }
const _hoisted_58 = {
  key: 0,
  class: "col text-center"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "h-100 text-nowrap btn btn-outline-secondary w-100 session-detail"
}, "詳細", -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  key: 1,
  class: "col text-center"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-start icon-me-2 icon-add" }, "視聴リストに追加", -1)
const _hoisted_63 = {
  key: 0,
  class: "small d-block text-center"
}
const _hoisted_64 = {
  key: 1,
  type: "button",
  class: "h-100 text-nowrap btn-cols-max btn btn-accent2 w-100 session-add disabled text-white",
  disabled: "disabled"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-start icon-me-2 icon-remove" }, "視聴リストから削除", -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-start icon-me-2 icon-remove" }, "視聴をキャンセル", -1)
const _hoisted_68 = [
  _hoisted_67
]



  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'PickupSessionView',
  props: {
    single: { type: Boolean },
    session: { type: Object },
    isFilteredSession: { type: Boolean },
    isFiltered: { type: Boolean },
    login: { type: Boolean },
    isCartInSession: { type: Boolean },
    isEnrtySession: { type: Boolean },
    webinarMainLabel: { type: String },
    webinarSubLabel: { type: String },
    eventHolding: { type: Boolean },
    eventAPIisAlive: { type: Boolean },
    linkBaseURL: { type: String }
  },
  emits: ['addItem', 'removeItem', 'cancelItem'],
  setup(__props, { emit: emits }) {

const props = __props;

  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  

  const addItem = (id: string) => {
    emits('addItem', id);
  }

  const removeItem = (id: string) => {
    emits('removeItem', id);
  }

  const cancelItem = (session: object) => {
    emits('cancelItem', session);
  }

  const openLink = (url: string) => {
    if (props.linkBaseURL) {
      url = props.linkBaseURL + url;
    }
    window.open(url, "_blank", "noreferrer");
  }

  const openLinkSameDomain = (url: string) => {
    window.open(url, "_blank", "noreferrer");
  }

return (_ctx: any,_cache: any) => {
  return (__props.session.id)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([[
      __props.isFiltered ? __props.isFilteredSession ? '' : 'opacity-25' : '',
      __props.isCartInSession ? 'bg-cartin-session' : '',
      __props.isEnrtySession ? 'bg-entry-session' : '',
      __props.single ? 'border-primary' : 'border-accent3'
    ], "card text-decoration-none text-dark"]),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (__props.single ? false : __props.session.dtlable_status ? openLinkSameDomain('/?seminar_session=seminar_' + __props.session.id) : false))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["card-header text-center fw-bold", __props.single ? 'text-bg-primary' : 'text-bg-accent3'])
        }, _toDisplayString(__props.single ? __props.session.label : '注目のセッション'), 3),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.session.date), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.session.timeStart) + "〜" + _toDisplayString(__props.session.timeEnd), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.session.categories, (category, o) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: o,
                    class: "me-2 badge border text-bg-light rounded text-nowrap mb-1"
                  }, _toDisplayString(category), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(__props.session.label), 1)
              ]),
              _createElementVNode("div", {
                class: "fs-5 fw-bold session-title",
                innerHTML: __props.session.title
              }, null, 8, _hoisted_10),
              _createElementVNode("div", {
                class: "my-3 small session-description",
                innerHTML: __props.session.description
              }, null, 8, _hoisted_11),
              (__props.single)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (__props.session.level)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.session.level, (level, p) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: p,
                                class: "me-2"
                              }, _toDisplayString(level), 1))
                            }), 128))
                          ]),
                          (__props.session.level_memo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("div", {
                                  class: "small",
                                  innerHTML: __props.session.level_memo
                                }, null, 8, _hoisted_17)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (__props.session.participants)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", {
                            class: "small",
                            innerHTML: __props.session.participants
                          }, null, 8, _hoisted_20)
                        ]))
                      : _createCommentVNode("", true),
                    (__props.session.merit)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("div", {
                            class: "small",
                            innerHTML: __props.session.merit
                          }, null, 8, _hoisted_23)
                        ]))
                      : _createCommentVNode("", true),
                    (__props.session.needs)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", {
                            class: "small",
                            innerHTML: __props.session.needs
                          }, null, 8, _hoisted_26)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.session.speakers, (speaker, o) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(o === __props.session.speakers.length - 1 ? '': 'mb-3'),
                  key: o
                }, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(speaker.role), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("img", {
                        src: speaker.photo,
                        class: "profile-photo",
                        alt: ""
                      }, null, 8, _hoisted_32)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        (speaker.company)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "speaker-company",
                              innerHTML: speaker.company
                            }, null, 8, _hoisted_35))
                          : _createCommentVNode("", true),
                        (speaker.department)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "speaker-department",
                              innerHTML: speaker.department
                            }, null, 8, _hoisted_36))
                          : _createCommentVNode("", true),
                        (speaker.jobtitle)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "speaker-jobtitle",
                              innerHTML: speaker.jobtitle
                            }, null, 8, _hoisted_37))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createTextVNode(_toDisplayString(speaker.name), 1),
                        _hoisted_39
                      ]),
                      (__props.single && speaker.profile)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "mt-2 fs-lg-8 speaker-profile",
                            innerHTML: speaker.profile
                          }, null, 8, _hoisted_40))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_41, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.session.images, (image, n) => {
                return (_openBlock(), _createElementBlock("div", { key: n }, [
                  _createElementVNode("figure", _hoisted_42, [
                    _createElementVNode("img", {
                      src: image,
                      class: "img-fluid w-100",
                      alt: ""
                    }, null, 8, _hoisted_43)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            (__props.login && __props.isEnrtySession)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  (__props.eventHolding && __props.session.watch && __props.session.webinarMainURL && __props.webinarMainLabel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (openLink(__props.session.webinarMainURL)), ["stop","prevent"])),
                          class: "btn btn-lg rounded-1 btn-accent w-100"
                        }, [
                          _createElementVNode("span", _hoisted_47, _toDisplayString(__props.webinarMainLabel), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.eventHolding && __props.session.watch && __props.session.webinarSubURL && __props.webinarSubLabel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (openLink(__props.session.webinarSubURL)), ["stop","prevent"])),
                          class: "btn btn-sm btn-accent w-100"
                        }, [
                          _createElementVNode("span", _hoisted_49, _toDisplayString(__props.webinarSubLabel), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_50, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.session.documents, (doc, p) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(p === __props.session.documents.length - 1 ? '' : 'mb-2'),
                        key: p
                      }, [
                        (doc.documentStatus === 'ready')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              onClick: _withModifiers(($event: any) => (openLink(doc.documentURL)), ["stop","prevent"]),
                              class: "btn btn-sm btn-dark w-100 session-document"
                            }, [
                              _createElementVNode("span", _hoisted_52, "講演資料" + _toDisplayString(__props.session.documents.length != 1 ? '(' + (p + 1).toString() + ')' : '') + "ダウンロード", 1)
                            ], 8, _hoisted_51))
                          : _createCommentVNode("", true),
                        (doc.documentStatus === 'preparation')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                              _createElementVNode("span", _hoisted_54, "講演資料" + _toDisplayString(__props.session.documents.length != 1 ? '(' + (p + 1).toString() + ')' : '') + "は後日公開予定", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (doc.documentStatus === 'private')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                              _createElementVNode("span", _hoisted_56, "講演資料" + _toDisplayString(__props.session.documents.length != 1 ? '(' + (p + 1).toString() + ')' : '') + "は非公開", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_57, [
              (!__props.single && __props.session.dtlable_status)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_60))
                : _createCommentVNode("", true),
              (__props.eventHolding && __props.session.regabel_status !== 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    (!__props.isCartInSession && !__props.isEnrtySession && __props.session.regabel_status !== 3)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "h-100 text-nowrap btn btn-accent2 w-100 session-add",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (addItem(__props.session.layout_id)), ["stop","prevent"]))
                        }, [
                          _hoisted_62,
                          (__props.session.regabel_status === 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_63, "（残席わずか）"))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (!__props.isCartInSession && !__props.isEnrtySession && __props.session.regabel_status === 3)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_64, "（満席）"))
                      : _createCommentVNode("", true),
                    (__props.isCartInSession && !__props.isEnrtySession)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          class: "h-100 text-nowrap btn btn-secondary w-100 session-remove",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (removeItem(__props.session.layout_id)), ["stop","prevent"]))
                        }, _hoisted_66))
                      : _createCommentVNode("", true),
                    (__props.isEnrtySession)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          type: "button",
                          class: "h-100 text-nowrap btn btn-secondary w-100 session-cancel",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (cancelItem(__props.session)), ["stop","prevent"]))
                        }, _hoisted_68))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})